/*
 * Copyright (c) 2024. Bluemate B.V.
 */

import React, {useContext, useEffect} from 'react';

import {Outlet} from 'react-router';

import {resetReviewAnalyticsMem} from '../../util/reviewAnalyticsUtil';

import {AppContext} from '../misc/appContext';

export default function ReviewAnalyticsRoute() {
    const {account} = useContext(AppContext).accountContext;

    useEffect(() => {
        return function () {
            resetReviewAnalyticsMem();
        };
    }, [account?.id]);

    return <Outlet />;
}
